import React from 'react';
import classes from './Project.module.css';
import ScrollDown from '../UI/ScrollDownIndicator/ScrollDown';
import Header from '../UI/Header/Header';
import Projects from '../Projects/Projects';
import Canvas from '../Canvas/Canvas';

const Project = () => {
  return (
    <>
      <section className={classes.project}>
        <Canvas />
        <Header header="PROJECTS" styles={classes['project-text']} />
        <ScrollDown link="#project" />
      </section>
      <div id="project">
        <Projects />
      </div>
    </>
  );
};

export default Project;
